import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import RoleList from './RoleList';
import Permission from '../Common/Permission';
import { enableRolePermission } from '../../../actions/users';

const UserRoleList = (props) => {
    const { isRequesting, roleListById } = props;
    const [activeRoleId, setActiveRoleId] = useState(null);

    const updateRolePermission = (params, cb) => {
        props.actions.enableRolePermission({ ...params, role_id: activeRoleId }, cb);
    }

    return <Row className="user-role-list animate animate__fadeIn">
        <Col className="role-table" lg={5} md={5} sm={5}>
            <RoleList activeRoleId={activeRoleId} setActiveRoleId={setActiveRoleId} />
        </Col>
        <Col className="role-permission-table">
            {activeRoleId && <Permission
                id={activeRoleId}
                isRequesting={isRequesting}
                permissionInfo={roleListById[activeRoleId].permission}
                updatePermission={updateRolePermission} />}
        </Col>
    </Row>
};

const mapStateToProps = state => ({
    roleListById: state.users.roleListById.payload,
    isRequesting: state.users.roleListById.isRequestingPermission
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ enableRolePermission }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRoleList);